import axios from 'axios';

export const axiosAuth = axios.create({
  baseURL: process.env.REACT_APP_API_HOST + '/auth',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});

export const axiosCms = axios.create({
  baseURL: process.env.REACT_APP_API_HOST + '/cms',
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
});



// WEBPACK FOOTER //
// ./src/Axios.js